import { createApi } from "@reduxjs/toolkit/query/react"
import { authQuery } from "./authQuery"

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: authQuery,
  endpoints: (builder) => ({
    logout: builder.mutation<boolean, void>({
      query: () => ({
        url: "/auth/logout",
        method: "POST",
      }),
      transformResponse: (response: { ok: boolean }) => response.ok,
    }),
  }),
})

export const { useLogoutMutation } = authApi
